import { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { handleError } from 'src/contexts/utils/handleError';
import { DELETE_CONTACT, SET_LOADING } from 'src/contexts/types';
import { TContactActionTypes } from '../types';

export type TBulkDeleteContactsPayload = {
    contactIds?: string[];
    filters?: Record<string, unknown>;
};

export type TBulkDeleteContactsResponse = {
    deleted: string[];
};

export const bulkDeleteContacts = async (
    dispatch: Dispatch<TContactActionTypes>,
    values: TBulkDeleteContactsPayload,
    callback?: () => void
): Promise<TBulkDeleteContactsResponse | undefined> => {
    dispatch({ type: SET_LOADING });

    try {
        const res = await ApiV2.post(
            '/contacts/bulk-delete',
            values,
            HEADERS({
                isReadPermissionNecessary: false,
            })
        );

        if (callback) callback();
        dispatch({ type: DELETE_CONTACT });

        return res.data.data;
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
